mainApp.component('ruleViewer', {
    template: '<div ng-include="$ctrl.templateUrl">',
    bindings: {
        ruleType: '@',
        item: '<'
    },
    controller: function($state, IconsService) {
        const ctrl = this;

        ctrl.$onInit = function() {
            ctrl.icons = IconsService.getIcons();

            ctrl.actionData = {
                "ALLOW":{"name":"Allow","icon":"allow",class:"action-allow"},
                "BLOCK":{"name":"Block","icon":"block",class:"action-block"},
                "MONITOR":{"name":"Monitor","icon":"monitor",class:"action-monitor"},
                "PROMPT":{"name":"Prompt","icon":"prompt",class:"action-alert"}
            };
        };

        ctrl.$onChanges = function(changes) {
            if (changes.ruleType && ctrl.ruleType) {
                ctrl.templateUrl = '/public/components/discovery/rule-ref/' + ctrl.ruleType + '.component.html';
            }
        }
    },
});